import React from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';

import { useSharingTools } from '../../../../hooks/useSharingTools';
import type { Platform } from '../../../../shared/constants';
import { SharingToolsCardWrapperVariant1 } from '../../../SharingToolsCardWrapper';

import { ReadyToSharePostsCardLoading } from './index';

/**
 * Loading skeleton for ReadyToSharePostsCard.
 * Displays placeholder content with shimmer effect while post data is being fetched.
 */
export const ReadyToSharePostsCardLoadingVariant1: React.FC<Props> = ({
	platform = 'facebook',
	title,
	description,
}) => {
	// TODO: Pass data from useSharingTools
	const { actions } = useSharingTools();

	return (
		<SharingToolsCardWrapperVariant1
			title={title}
			description={description}
			primaryActionOnClick={actions.navigateToReadyToSharePosts}
		>
			<ReadyToSharePostsCardLoading platform={platform} />
		</SharingToolsCardWrapperVariant1>
	);
};

type Props = Readonly<{
	platform?: Platform;
	title?: TranslationKey;
	description?: TranslationKey;
}>;
